module.exports = "https://static.wagwalking.com/_next/static/images/404-error-5c8b36fce4e165d56afdce358ccacb05.png";